import React, { useState } from "react";
import { Autocomplete, TextField, Chip, Typography, Box } from "@mui/material";
import { X } from "@phosphor-icons/react";
import PropTypes from "prop-types";

const RecipientDropdown = (props) => {
  const { selectedData, setSelectedData, allRecipients, setShowHelper, error } = props;

  const [inputValue, setInputValue] = useState("");

  return (
    <Autocomplete
      multiple
      options={allRecipients}
      value={selectedData}
      open={inputValue?.length > 0}
      inputValue={inputValue}
      onInputChange={(e, value) => setInputValue(value)}
      onChange={(e, newValue) => {
        const filtered = newValue.filter((val) => !val?.already_added);
        setSelectedData(filtered);
      }}
      onClick={() => setShowHelper(false)}
      disableCloseOnSelect
      getOptionLabel={(option) => option.full_name}
      getOptionDisabled={(option) => option?.already_added}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={option?.id}
            label={option?.full_name}
            {...getTagProps({ index })}
            deleteIcon={<X size={13} />}
            sx={{
              backgroundColor: "#DAE6F7",
              color: "#364151",
              fontWeight: 500,
              fontSize: "12px",
              borderRadius: "20px",
              paddingX: "8px",
              margin: "4px 4px 4px 0",
              height: "30px",
            }}
          />
        ))
      }
      renderOption={(props, option) => {
        return (
          <Box
            component="li"
            {...props}
            className="mui-option"
            sx={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-between",
              color: option?.already_added ? "#7C8DA6" : "inherit",
              fontSize: "14px",
              fontFamily: "manrope",
              px: 2,
              py: 1,
              cursor: option?.already_added ? "not-allowed" : "pointer",
              "&:hover": {
                backgroundColor: option?.already_added
                  ? "transparent"
                  : "#F3F4F7",
              },
            }}
          >
            <span>{option?.full_name}</span>
            {option?.already_added && (
              <Typography
                variant="body2"
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  ml: 1,
                }}
              >
                Already Added
              </Typography>
            )}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={"Add Recipient"}
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "6px",
              minHeight: "40px",
              fontFamily: "manrope",
              fontSize: "13px",
              paddingY: "2px",
              alignItems: "center",
              padding: "6px 10px!important",
              "& fieldset": {
                borderColor: error ? "#d32f2f" : "#DDE2E9",
              },
              "&:hover fieldset": {
                borderColor: error ? "#d32f2f" : "#0C53BB",
              },
              "&.Mui-focused fieldset": {
                border: "1px solid",
                borderColor: error ? "#d32f2f" : "#0C53BB",
                boxShadow: error
                  ? "0px 0px 0px 2px rgba(211, 47, 47, 0.2)"
                  : "0px 0px 0px 2px rgba(12, 83, 187, 0.2)",
              },
            },
            "& .MuiInputBase-input": {
              padding: "6px 0",
            },
            "& input::placeholder": {
              opacity: selectedData?.length > 0 ? 0 : 1,
              color: "#5A6C87",
              fontSize: "13px",
              fontFamily: "manrope",
              fontWeight: "500",
            },
          }}
        />
      )}
      sx={{
        width: "100%",
        fontFamily: "manrope",
        "& .MuiAutocomplete-popupIndicator": {
          display: "none",
        },
        "& .MuiAutocomplete-listbox": {
          "& .MuiAutocomplete-option": {
            "& .MuiBox-root": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              fontSize: "14px",
              fontFamily: "manrope",
              py: "8px",
            },
          },
        },
        "& .MuiAutocomplete-inputRoot": {
          minHeight: "40px !important",
          alignItems: "center",
        },
        "& .MuiAutocomplete-input": {
          padding: "0 !important",
        },
        "& .MuiAutocomplete-tag": {
          margin: "2px 4px 2px 0",
          height: "28px",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiPaper-root": {
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          borderRadius: "6px",
        },
        "& .MuiAutocomplete-endAdornment": {
          display: selectedData?.length === 0 ? "flex" : "none",
        },
      }}
    />
  );
};

export default RecipientDropdown;

RecipientDropdown.propTypes = {
  selectedData: PropTypes.array,
  setSelectedData: PropTypes.func.isRequired,
  allRecipients: PropTypes.array.isRequired,
  setShowHelper: PropTypes.func,
  error: PropTypes.string,
};
